var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2382_14267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5C14.6963 8.50165 13.4465 9.02028 12.5246 9.94213C11.6028 10.864 11.0842 12.1138 11.0825 13.4175H13.5825C13.5825 12.0837 14.6675 11 16 11C17.3325 11 18.4175 12.0837 18.4175 13.4175C18.4175 14.165 17.8163 14.7075 16.8975 15.45C16.5974 15.6851 16.3091 15.935 16.0338 16.1988C14.7863 17.445 14.75 18.7688 14.75 18.9163V19.75H17.25L17.2488 18.9587C17.25 18.9387 17.29 18.4763 17.8 17.9675C17.9875 17.78 18.2238 17.5925 18.4688 17.395C19.4425 16.6063 20.9163 15.415 20.9163 13.4175C20.9153 12.1138 20.397 10.8638 19.4753 9.94184C18.5536 9.01988 17.3037 8.50132 16 8.5ZM14.75 21H17.25V23.5H14.75V21Z",
    fill: "#656E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1C7.729 1 1 7.729 1 16C1 24.271 7.729 31 16 31C24.271 31 31 24.271 31 16C31 7.729 24.271 1 16 1ZM16 28.75C9.3835 28.75 3.25 22.6165 3.25 16C3.25 9.3835 9.3835 3.25 16 3.25C22.6165 3.25 28.75 9.3835 28.75 16C28.75 22.6165 22.6165 28.75 16 28.75Z",
    fill: "#656E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2382_14267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7559e2bb05b2576bedf00e62c76607ca.svg";
export { ForwardRef as ReactComponent };